import React from 'react';
import { IconPill } from '../../IconPill';
import { IconPillSizeOptionsEnum } from '@inter-ikea-kompis/component-icon-pill';
import Tooltip from '../../Popup/Tooltip';
import { translate } from '../../../services/L10n';
import { TOP } from '../../Popup/alignments';
import { useDispatch, useSelector } from 'react-redux';
import platform from '../../../util/platform';
import styles from '../ActionButtons.module.less';
import WallMeasurementsLegend from './WallMeasurementsLegend';
import Transition from '../../Transition';
import Portal from '../../utils/Portal';
import { selectIsMobile } from '../../../state/userAgent/userAgentSelectors';
import { selectIsWallResizerActive } from '../../../state/scene/sceneSelectors';
import { thunkToggleWallResizer } from '../../../state/scene/sceneThunks';
import { t } from '../../../translations';

const WallResizerIcon = () => {
  const readyToPortal = React.useRef(false);

  const isMobile = useSelector(selectIsMobile);
  const wallResizerActive = useSelector(selectIsWallResizerActive);

  const dispatch = useDispatch();
  const toggleWallResizer = () => dispatch(thunkToggleWallResizer());

  React.useEffect(() => {
    readyToPortal.current = true;
  }, []);

  const renderLegend = () => (
    <Transition in={wallResizerActive} classNames={styles}>
      <WallMeasurementsLegend />
    </Transition>
  );

  const renderPortal = () =>
    readyToPortal.current && (
      <Portal container="#product-swiper">{renderLegend()}</Portal>
    );

  const renderLegendOrPortal = () =>
    isMobile ? renderPortal() : renderLegend();

  return (
    <div className={styles.wrapper}>
      <Tooltip alignment={TOP} content={translate(t.TOOLTIP_WALL_MEASUREMENTS)}>
        <IconPill
          onSelect={toggleWallResizer}
          selected={wallResizerActive}
          iconName={'WallMeasurementIcon'}
          iconPillSize={
            platform.isKiosk
              ? IconPillSizeOptionsEnum.medium
              : IconPillSizeOptionsEnum.small
          }
          disabled={false}
          data-testid="wall-resize-button"
        />
      </Tooltip>
      {renderLegendOrPortal()}
    </div>
  );
};

export default WallResizerIcon;
